import apiClient from '@/lib/axios'

export const getUserMemories = async (payload: MemoryPaginationPayload): Promise<MemoryPaginationResponse> => {
  const response = await apiClient.get('/memory/semantic', {
    params: payload,
  })
  return response.data
}

export const deleteUserMemory = async (payload: DeleteMemoryPayload): Promise<DeleteMemoryResponse> => {
  const response = await apiClient.delete(`/memory/semantic`, {
    data: payload,
  })
  return response.data
}

